import Address from "@mapmycustomers/shared/types/Address";

const getZoomLevelByAddress = (address: Address) => {
  if (address.address) {
    return 13;
  } else if (address.city) {
    return 10;
  } else if (address.region) {
    return 7;
  }
  return 4;
};

export default getZoomLevelByAddress;
